module.exports = __webpack_public_path__ + "static/media/oiliness.bbf02624.svg";